import React, { useEffect, useState } from "react";
import "./LoadingCOA.css";
import LoadingIcon from "../Icons/loadingIclon";

//loading bar that displays on any page loading
const LoadingCOA = () => {
	const words = [
		"Gathering Terpenes",
		"Collecting Cannabinoids",
		"Analyzing COA Data",
		"Extracting Additional Test Data",
		"Generating Color",
		"Analyzing Testing Standards",
		"Gathering Additional Info",
		"Determining Cannabinoid Type",
		"Determining Color",
		"Processing Results",
	];
	const [currentWord, setCurrentWord] = useState(words[0]);

	// useEffect(() => {
	// 	const intervalId = setInterval(() => {
	// 		setCurrentWord((prevWord) => {
	// 			const currentIndex = words.indexOf(prevWord);
	// 			return words[(currentIndex + 1) % words.length];
	// 		});
	// 	}, 3000); // Change word every 2 seconds

	// 	return () => clearInterval(intervalId); // Clean up on unmount
	// }, []);
	return <div className="loading-words"><LoadingIcon /></div>;
};

export default LoadingCOA;
